import React, { useState, useEffect } from "react";
import Topbar from "../../components/topbar/Topbar";
import PartSearchTab from "../../components/partsCatalogPartSearch/PartSearchTab";
import ModelSearchTab from "../../components/partsCatalogModelSearch/ModelSearchTab";
import BulkUploadTab from "../../components/partsCatalogBulkUpload/BulkUploadTab";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../home/home.css";
import "../../components/tabmenu/tabmenu.css";
import "./partsCatalogEditor.css";

const TABS = ["PART SEARCH", "MODEL SEARCH", "BULK UPLOAD"];

export default function PartsCatalogEditor() {
  const [selectedTab, setSelectedTab] = useState(TABS[0]);
  const [isContentVisible, setIsContentVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsContentVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const renderTabPanel = () => {
    switch (selectedTab) {
      case "PART SEARCH":
        return <PartSearchTab />;
      case "MODEL SEARCH":
        return <ModelSearchTab />;
      case "BULK UPLOAD":
        return <BulkUploadTab />;
      default:
        return null;
    }
  };

  return (
    <div className="mainPageContent">
      <Topbar title="PARTS CATALOG EDITOR" />
      <div className="tabMenuContainer" role="tablist" aria-label="Parts catalog sections">
        {TABS.map((tab) => (
          <div
            key={tab}
            className={`tabItem ${selectedTab === tab ? "activeTab" : ""}`}
            onClick={() => setSelectedTab(tab)}
            role="tab"
            aria-selected={selectedTab === tab}
            tabIndex={selectedTab === tab ? 0 : -1}
          >
            {tab}
          </div>
        ))}
      </div>
      <div className="floating-elements">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
        <div className="floating-circle circle-4"></div>
        <div className="floating-square square-1"></div>
        <div className="floating-square square-2"></div>
        <div className="floating-square square-3"></div>
      </div>
      <div
        className={`contentWrapper ${isContentVisible ? "content-visible" : ""}`}
        role="tabpanel"
      >
        {renderTabPanel()}
      </div>
    </div>
  );
}
